import { render, staticRenderFns } from "./CRSidebarDialog.vue?vue&type=template&id=6c471864&scoped=true"
import script from "./CRSidebarDialog.vue?vue&type=script&lang=js"
export * from "./CRSidebarDialog.vue?vue&type=script&lang=js"
import style0 from "./CRSidebarDialog.vue?vue&type=style&index=0&id=6c471864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c471864",
  null
  
)

export default component.exports